import React, { createContext, useContext } from 'react';

// Create context with a safe default value
const ThreeContext = createContext({
  renderer: null,
  canvasRef: { current: null },
  isReady: true // Always ready since we're not managing a renderer
});

export const useThree = () => useContext(ThreeContext);

/**
 * Simplified ThreeProvider that acts as a pass-through.
 * ForceGraph3D manages its own WebGL renderer, so we don't need to create one here.
 * Keeping the provider structure to avoid breaking existing context consumers.
 */
export const ThreeProvider = ({ children }) => {
  return (
    <ThreeContext.Provider value={{ renderer: null, canvasRef: { current: null }, isReady: true }}>
      {children}
    </ThreeContext.Provider>
  );
};
